import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const ImageSlider = ({ images, sliderSettings = {} }) => {
    const defaultSettings = {
        dots: true,
        infinite: true,
        autoplay: true,
        autoplaySpeed: 3000,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        ...sliderSettings, // Allow overriding defaults
    };

    return (
        <Slider {...defaultSettings}>
            {images.map((image, index) => (
                <div key={index} className="w-full">
                    <img
                        src={image}
                        alt={`Slide ${index + 1}`}
                        className="rounded-lg shadow-lg w-full object-fit"
                        style={{
                            height: "100%",
                            maxHeight: "600px", // Adjust for smaller screens
                        }}
                    />
                </div>
            ))}
        </Slider>
    );
};

export default ImageSlider;